import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { BACKEND_URL } from "../lib/backendUrl";
const API = `${BACKEND_URL}/api`;

const ReferralRedirect = () => {
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const track = async () => {
      try {
        await axios.get(`${API}/affiliate/track/${username}`);
      } catch {}
      localStorage.setItem('ref', username);
      navigate(`/register?ref=${username}`, { replace: true });
    };
    track();
  }, [username, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a1628] via-[#0d1f35] to-[#0a1628] flex items-center justify-center">
      <p className="text-gray-400 text-sm">Redirecting...</p>
    </div>
  );
};

export default ReferralRedirect;
